export const state = () => {
  return {
    sort: null,
    columns: []
  }
}
